import React from 'react';
// import PropTypes from 'prop-types';
import HistogramCard, {
  useHistogramCard,
} from 'partial/dashboard/HistogramCard';
import DashboardSchemeCard, {
  useSchemeCard,
} from 'partial/dashboard/DashboardSchemeCard';
import CountCard from 'partial/dashboard/CountCard';
import ThumbIcon from 'partial/components/ThumbIcon';
import { AiOutlineCodeSandbox } from 'react-icons/ai';
import PageWrapper from 'partial/components/PageWrapper';
import { CashIcon, ViewListIcon } from '@heroicons/react/outline';
import {
  useCountCard,
  useTransactionHistogram,
  useAmountHistogram,
  useTopMerchantScheme,
  useTransactionScheme,
} from 'core-modules/dashboard/hooks';

const txnHistogramOptions = [
  {
    id: 'transaction',
    label: 'By Transaction',
    hook: useTransactionHistogram,
    defaultChart: 'line',
  },
];

const amtHistogramOptions = [
  {
    id: 'amount',
    label: 'By Amount',
    hook: useAmountHistogram,
    defaultChart: 'bar',
  },
];

const schemeOptionsA = [
  {
    id: 'top_merchant',
    label: 'Top Merchant',
    hook: useTopMerchantScheme,
    downloadCsv: (row) => ({
      Label: row.label,
      Txn: row.transaction,
      Amount: row.amount,
    }),
    tableFormat: [
      {
        label: 'Label',
        // eslint-disable-next-line
        key: ({ icon, label }) => (
          <span className="flex items-center space-x-1">
            <ThumbIcon
              className="h-7 w-7 inline-block rounded-full"
              url={icon}
              alt={label}
            />
            <span>{label}</span>
          </span>
        ),
        id: 'label',
        className: 'font-bold',
      },
      {
        label: 'Txn',
        key: 'transaction',
        id: 'transaction',
        sortKey: 'transaction',
      },
      { label: 'Amount', key: 'amount', id: 'amount', sortKey: 'amount' },
    ],
    defaultChart: 'pie',
    defaultSort: 'transaction:asc',
  },
];

const schemeOptionsB = [
  {
    id: 'transactions',
    label: 'Transactions',
    hook: useTransactionScheme,
    downloadCsv: (row) => ({
      Label: row.label,
      Txn: row.transaction,
      Amount: row.amount,
    }),
    tableFormat: [
      {
        label: 'Label',
        key: 'label',
        id: 'label',
        className: 'font-bold',
      },
      {
        label: 'Txn',
        key: 'transaction',
        id: 'transaction',
      },
      { label: 'Amount', key: 'amount', id: 'amount' },
    ],
    defaultSort: 'id:desc',
    table: true,
    pie: false,
    bar: true,
  },
];

function ChannelDashboard() {
  const transactionHistogram = useHistogramCard(txnHistogramOptions);
  const amtHistogram = useHistogramCard(amtHistogramOptions);
  const schemePropsA = useSchemeCard(schemeOptionsA);
  const schemePropsB = useSchemeCard(schemeOptionsB);
  return (
    <PageWrapper className="space-y-5">
      {/* Counts Here */}
      <dl className="mt-5 grid grid-cols-1 rounded-lg bg-white overflow-hidden shadow-primary divide-y divide-gray-200 md:grid-cols-3 md:divide-y-0 md:divide-x">
        <CountCard
          name="totals_channels"
          label="Total Channels"
          icon={AiOutlineCodeSandbox}
          hook={useCountCard}
        />
        <CountCard
          name="total_transactions"
          label="Total Transactions"
          icon={ViewListIcon}
          hook={useCountCard}
        />
        <CountCard
          name="total_amount"
          label="Total Amount"
          icon={CashIcon}
          hook={useCountCard}
        />
      </dl>
      {/* Counts Here */}
      <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
        <div className="col-span-1 xl:col-span-2">
          <HistogramCard {...transactionHistogram} />
        </div>
        <div>
          <DashboardSchemeCard {...schemePropsA} />
        </div>
      </div>

      <div className="grid grid-cols-1 xl:grid-cols-3 gap-5">
        <div className="col-span-1 xl:col-span-2">
          <HistogramCard {...amtHistogram} />
        </div>
        <div>
          <DashboardSchemeCard {...schemePropsB} />
        </div>
      </div>
    </PageWrapper>
  );
}

ChannelDashboard.propTypes = {};

export default ChannelDashboard;
